import React from 'react';
import { Image } from '../../../../shared/src/components/Image';
import { useDispatch, useSelector } from 'react-redux';
import { useAsgActions } from '../../../../shared/src/hooks/use-asg-actions.hook';
import { useTranslations } from '../../../../shared/src/hooks/use-translations.hook';
import { InGameService } from '../../services/InGameService';

export const WinnersGameItem = ({ onOpenGame, data }) => {
    const {
        id,
        playerName,
        currencySymbol,
        winAmount,
        gameName,
        img,
        imgWebp
    } = data;

    const { t } = useTranslations();
    const dispatch = useDispatch();
    const { closeAndLoadGame, showRegistration } = useAsgActions();
    const { isLoggedIn } = useSelector((state) => state.player);
    const { gamesById } = useSelector((state) => state.casino);

    const openGame = () => {
        InGameService.openGame({
            gameId: id,
            gamesById,
            isLoggedIn,
            dispatch,
            closeAndLoadGame,
            showRegistration,
        });
    };

    return <div className="winners-game-component__result-item">
        <Image
            onClickHandler={() => {
                openGame();
                onOpenGame(data);
            }}
            className="result__image"
            images={{ default: img, webp: imgWebp }}
        />
        <div className="result__text-wrapper">
            <div className="result__name">
                {`${playerName} ${t('won')}`}
            </div>
            <div className="result__name currency">
                { currencySymbol } { Math.trunc( winAmount ) }
            </div>
            <div
                onClick={() => {
                    openGame();
                    onOpenGame(data);
                }}
                className="result__name play-btn">
                {`${t('play').toLowerCase()} ${gameName}`}
            </div>
        </div>
    </div>;
};
